import { render, staticRenderFns } from "./simple-header.vue?vue&type=template&id=0108e5be&"
import script from "./simple-header.vue?vue&type=script&lang=js&"
export * from "./simple-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports